import { useEffect } from "react";
import Swal from "sweetalert2";
import discardChanges from "../static/images/svgs/icon/discardChanges.svg";
import "./customStyles.css";
import { useAuth } from "../context/auth";
import { notification } from "antd";

const DeleteAction = ({ name, type, onOk, onCancel, editRecord, openModalActionDelete }) => {
  const { accessToken } = useAuth();

  const showModalDelete = () => {
    Swal.fire({
      title: `Delete ${name}?`,
      text: `Do you want to delete this ${name}?`,
      imageUrl: discardChanges,
      showCancelButton: true,
      confirmButtonText: "Confirm",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      buttonsStyling: false,
      customClass: {
        popup: "sw-popup",
        htmlContainer: "sw-content",
        confirmButton: "sw-btn-default sw-btn-confirm",
        cancelButton: "sw-btn-default sw-btn-cancel",
      },
      async preConfirm() {
        const url = new URL(`/api/${type}/${editRecord.id}`, window.location);

        const res = await fetch(url, {
          method: 'DELETE',
          headers: { 'X-ACCESS-TOKEN': accessToken },
        });
        if (!res.ok) throw new Error(`Can't delete already used item`);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Deleted Successfully !",
          text: "Successfully deleted  data.",
          showConfirmButton: false,
          timer: 1500,
        });
        onOk();
      } else {
        onCancel();
      }
    }).catch(() => {
      onCancel();
      Swal.close();
      notification["error"]({
        message: "Can't delete already used item",
      });
    });
  };

  useEffect(() => {
    if (openModalActionDelete) showModalDelete();

    // eslint-disable-next-line
  }, [openModalActionDelete]);

  return <div></div>;
};

export default DeleteAction;
